import { Form, Formik } from 'formik';
import { memo } from 'react';
import { object, string } from 'yup';

import { FormikField } from '@air/formik-field';
import { Button } from '@air/primitive-button';
import { Input } from '@air/primitive-input';
import { Modal, ModalTitle } from '@air/primitive-modal';

import { uuidRegExpString } from '~/utils/Url';

const VALIDATION = object().shape({
  workspaceId: string()
    .matches(new RegExp(`.*(${uuidRegExpString}).*`, 'i'), 'Invalid workspace ID')
    .required(),
});
export type WorkspaceIdModalProps = {
  onSubmit: (workspaceId: string) => void;
};

export const WorkspaceIdModal = memo(({ onSubmit }: WorkspaceIdModalProps) => {
  return (
    <Modal isOpen>
      <header className="-mx-6 -mt-6 mb-6 rounded-t-6 bg-pigeon-900 p-6 text-white">
        <ModalTitle className="text-white">Workspace ID</ModalTitle>
      </header>
      <div className="flex flex-col gap-6">
        <Formik
          initialValues={{ workspaceId: '' }}
          onSubmit={(values) => {
            onSubmit(values.workspaceId);
          }}
          validationSchema={VALIDATION}
        >
          <Form className="flex flex-col gap-6">
            <FormikField
              component={<Input required type="text" size="large" />}
              id="workspaceId"
              label="Workspace ID"
              name="workspaceId"
            />
            <Button className="bg-pigeon-900 hover:bg-pigeon-800" size="large" type="submit">
              Go to workspace
            </Button>
          </Form>
        </Formik>
        <div className="h-px w-full bg-pigeon-100" />
        <div className="font-semibold text-14">Recently used</div>
        <div className="flex flex-wrap gap-4">
          <button
            className="flex h-8 cursor-pointer items-center rounded-4 border border-pigeon-100 bg-pigeon-50 px-2 font-semibold text-12"
            type="button"
          >
            Workspace name
          </button>
        </div>
      </div>
    </Modal>
  );
});

WorkspaceIdModal.displayName = 'WorkspaceIdModal';
